import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import IconButton from 'srcReact/components/common2/IconButton'
import TooltipWrapper from 'srcReact/components/common2/TooltipWrapper'
import { getRatingEmojis, isMobileScreen } from 'srcReact/helpers/utils'
import Icon from 'srcReact/components/icons/Icon'
import { useTranslation } from 'react-i18next'

function EmojisForRating({
  size = 'large32',
  className,
  selectedValue = 0,
  showEmojiText = true,
  readOnly = false,
  handleRateMixr
}) {
  const { t } = useTranslation()
  const [selectedEmojiValue, setSelectedEmojiValue] = useState(0)

  const [ratingOptions, setRatingOptions] = useState([])
  useEffect(() => {
    const options = getRatingEmojis(t)
    setRatingOptions(options)
  }, [])

  useEffect(() => {
    setSelectedEmojiValue(selectedValue)
  }, [selectedValue])

  const handleChangeRating = (newRatingValue) => {
    if (!readOnly) {
      setSelectedEmojiValue(newRatingValue)
      if (handleRateMixr) {
        handleRateMixr(newRatingValue)
      }
    }
  }

  return (
    <div class={`${styles.emojis} ${className}`}>
      {ratingOptions.map((rating) => {
        const { icon, label, value } = rating
        return (
          <div
            className={`${styles.emoji}  ${styles[size]} ${selectedEmojiValue === value ? styles.selectedEmoji : ''} `}>
            {readOnly ? (
              <TooltipWrapper
                className='ratingTootip'
                position={isMobileScreen() ? 'left top' : 'top center'}
                triggerElement={<Icon name={icon} size={size} styleModifier={styles.emojiIcon} alt={label} />}
                content={<span>{label}</span>}
              />
            ) : (
              <IconButton
                key={value}
                className={`${styles.btnEmoji} `}
                onClick={() => handleChangeRating(value)}
                iconSize={size}
                iconName={icon}
                aria-label={label}
              />
            )}

            {showEmojiText && (
              <p className={styles.text} aria-label={label}>
                {label}
              </p>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default EmojisForRating
